var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let QboSideBar = class QboSideBar extends LitElement {
    constructor() {
        super(...arguments);
        this.collapseAttribute = `aria-expanded`;
        this.collapseSelector = `[data-qbo-toggle="collapse"]`;
        this.menuCollapsed = `false`;
        this.menuExpanded = `true`;
        this.menuShow = `qbo-show`;
    }
    updated(changedProperties) {
        /* Enable collapsing menus */
        const root = this;
        root.querySelectorAll(`${this.collapseSelector}`).forEach(function (btn) {
            btn.addEventListener('click', (e) => {
                const sibling = btn.nextElementSibling;
                if (btn.getAttribute(root.collapseAttribute) == root.menuCollapsed) {
                    if (sibling instanceof HTMLElement)
                        sibling.classList.add(root.menuShow);
                    btn.setAttribute(root.collapseAttribute, root.menuExpanded);
                }
                else {
                    if (sibling instanceof HTMLElement)
                        sibling.classList.remove(root.menuShow);
                    btn.setAttribute(root.collapseAttribute, root.menuCollapsed);
                }
            });
        });
    }
    render() { return html `<slot></slot>`; }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSideBar.prototype, "collapseAttribute", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSideBar.prototype, "collapseSelector", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSideBar.prototype, "menuCollapsed", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSideBar.prototype, "menuExpanded", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSideBar.prototype, "menuShow", void 0);
QboSideBar = __decorate([
    customElement('qbo-sidebar')
], QboSideBar);
export { QboSideBar };
